module.exports = __webpack_public_path__ + "img/Feature.8967defb.png";